export default __webpack_public_path__ + "static/media/20.43e35e01.png";